var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.$store.state.generatereport = true}}},[_vm._v("Generate Report")]),(_vm.$store.state.generatereport == true)?_c('GenerateReport'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }